import client from "./client";

const getVirtualWallets = () => client.get("/subsidiary/view/static/accounts");

export default { getVirtualWallets };
